/*
* @Author: tengmaoqing
* @Date:   2018-05-02 15:04:13
* @Last Modified by:   tengmaoqing
* @Last Modified time: 2018-06-12 17:52:03
*/

import { getTempOrder, getOrderDetail } from '@/apis/base';

export default {
  namespaced: true,
  state: () => {
    return {
      orderInfo: {},
      errInfo: null
    };
  },
  actions: {
    async getTempOrder ({ commit }, orderNum) {
      const res = await getTempOrder(orderNum);
      if (+res._errCode === 0) {
        commit('setOrderInfo', res._data);
        commit('setErrInfo', null);
        return;
      }
      //  订单过期
      if (res._errCode === '400008') {
        commit('setErrInfo', res);
      }
    },
    async getOrderDetail ({ commit }, orderNum) {
      const res = await getOrderDetail(orderNum);
      if (+res._errCode === 0) {
        commit('setOrderInfo', res._data);
        commit('setErrInfo', null);
      }
    }
  },
  mutations: {
    setOrderInfo (state, data) {
      state.orderInfo = data;
    },
    setErrInfo (state, data) {
      state.errInfo = data;
    }
  }
};



// WEBPACK FOOTER //
// ./src/core/createdOrder/store.js